module.exports = __webpack_public_path__ + "static/media/offer-unavailable.2145fba4.png";